import { render, staticRenderFns } from "./AccountsTab.vue?vue&type=template&id=fdaef1ba"
import script from "./AccountsTab.vue?vue&type=script&lang=js"
export * from "./AccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports